import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import { Card, Grid, DisplayItem } from '../generic';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    fontSize: 14,
  },
  head: {
    paddingTop: 7,
    paddingBottom: 7,
    fontWeight: 400,
  },
  cell: {
    paddingTop: 4,
    paddingBottom: 4,
  }
});

const formatDate = (value) => value ? moment(value).format('Do MMMM YYYY HH:mm') : '';

function ClearanceBureauResponses({ bureauResponse, referenceNumber, state }) {
  const classes = useStyles();

  if (!bureauResponse || bureauResponse.length === 0) {
    return (
      <Card>
        <h2>Clearing Bureau Responses</h2>
        <Grid container justifyContent='flex-start' alignItems='center' spacing={6}>
          <DisplayItem label="Our Status" value={state || ' '} />
          <DisplayItem label="Our Reference" value={referenceNumber || ' '} xs={4} />
        </Grid>
        <p>No bureau responses recorded yet.</p>
      </Card>
    );
  }

  return (
    <Card>
      <h2>Clearing Bureau Responses</h2>

      <Grid container justifyContent='flex-start' alignItems='center' spacing={6}>
        <DisplayItem label="Our Status" value={state || ' '} />
          <DisplayItem label="Our Reference" value={referenceNumber || ' '} xs={4} />
      </Grid>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="clearing bureau responses">
          <TableHead>
            <TableRow>
              <TableCell className={classes.head}>Bureau</TableCell>
              <TableCell className={classes.head}>Status</TableCell>
              <TableCell className={classes.head}>Status Code</TableCell>
              <TableCell className={classes.head}>Status Date</TableCell>
              <TableCell className={classes.head}>Reason</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bureauResponse.map((r, i) => (
              <TableRow key={`${r.bureau || 'bureau'}-${i}`}>
                <TableCell className={classes.cell}>{r.bureau || ''}</TableCell>
                <TableCell className={classes.cell}>{r.status || ''}</TableCell>
                <TableCell className={classes.cell}>{r.statusCode || ''}</TableCell>
                <TableCell className={classes.cell}>{formatDate(r.statusDate)}</TableCell>
                <TableCell className={classes.cell}>{r.statusReasonDescription || ''}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}

export default ClearanceBureauResponses;
